/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_User_DescInputs */

const es_tyc_definitions_user_desc = /** @type {(inputs: Tyc_Definitions_User_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier persona que acceda o utilice el Servicio.`)
};

const en_tyc_definitions_user_desc = /** @type {(inputs: Tyc_Definitions_User_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any person who accesses or uses the Service.`)
};

/**
* | output |
* | --- |
* | "Any person who accesses or uses the Service." |
*
* @param {Tyc_Definitions_User_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_user_desc = /** @type {((inputs?: Tyc_Definitions_User_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_User_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_user_desc(inputs)
	return en_tyc_definitions_user_desc(inputs)
});
export { tyc_definitions_user_desc as "tyc.definitions.user_desc" }